/** Safe Tiptap view access — editor.view throws before mount (React strict mode / nav). */

export function getSafeEditorView(editor) {
  if (!editor || editor.isDestroyed) return null
  try {
    return editor.view ?? null
  } catch {
    return null
  }
}

export function getSafeEditorDom(editor) {
  const view = getSafeEditorView(editor)
  return view?.dom ?? null
}
